export default class ToastEvent extends Event {
  public static OPEN_TOAST:string = 'openToast'
  public static CLOSE_TOAST:string = 'closeToast'

  public payload:any = {}
}
